export const FETCH_SUMMARY_START = "FETCH_SUMMARY_START";
export const FETCH_SUMMARY_SUCCESS = "FETCH_SUMMARY_SUCCESS";
export const FETCH_SUMMARY_FAIL = "FETCH_SUMMARY_FAIL";
export const UPDATE_REFURB_ESTIMATE_DATE = "UPDATE_REFURB_ESTIMATE_DATE";

export const SET_CURRENT_CARD_STEP = "SET_CURRENT_CARD_STEP";

export const DOWNLOAD_ATTACHMENT_START = "DOWNLOAD_ATTACHMENT_START";
export const DOWNLOAD_ATTACHMENT_SUCCESS = "DOWNLOAD_ATTACHMENT_SUCCESS";
export const DOWNLOAD_ATTACHMENT_FAIL = "DOWNLOAD_ATTACHMENT_FAIL";

export const FETCH_DATA_VALIDATION_START = "FETCH_DATA_VALIDATION_START";
export const FETCH_DATA_VALIDATION_SUCCESS = "FETCH_DATA_VALIDATION_SUCCESS";
export const FETCH_DATA_VALIDATION_FAIL = "FETCH_DATA_VALIDATION_FAIL";

export const FETCH_SERVICE_HISTORY_START = "FETCH_SERVICE_HISTORY_START";
export const FETCH_SERVICE_HISTORY_SUCCESS = "FETCH_SERVICE_HISTORY_SUCCESS";
export const FETCH_SERVICE_HISTORY_FAIL = "FETCH_SERVICE_HISTORY_FAIL";

export const POST_DATA_VALIDATION_START = "POST_DATA_VALIDATION_START";
export const POST_DATA_VALIDATION_SUCCESS = "POST_DATA_VALIDATION_SUCCESS";
export const POST_DATA_VALIDATION_FAIL = "POST_DATA_VALIDATION_FAIL";

export const SYNC_EE_DATA = "SYNC_EE_DATA";

export const FETCH_PRICING_START = "FETCH_PRICING_START";
export const FETCH_PRICING_SUCCESS = "FETCH_PRICING_SUCCESS";
export const FETCH_PRICING_FAIL = "FETCH_PRICING_FAIL";

export const FETCH_PRICING_MODAL_START = "FETCH_PRICING_MODAL_START";
export const FETCH_PRICING_MODAL_SUCCESS = "FETCH_PRICING_MODAL_SUCCESS";
export const FETCH_PRICING_MODAL_FAIL = "FETCH_PRICING_MODAL_FAIL";

export const FETCH_WARRANTY_START = "FETCH_WARRANTY_START";
export const FETCH_WARRANTY_SUCCESS = "FETCH_WARRANTY_SUCCESS";
export const FETCH_WARRANTY_FAIL = "FETCH_WARRANTY_FAIL";

export const POST_WARRANTY_START = "POST_WARRANTY_START";
export const POST_WARRANTY_SUCCESS = "POST_WARRANTY_SUCCESS";
export const POST_WARRANTY_FAIL = "POST_WARRANTY_FAIL";

export const FETCH_HOLDS_START = "FETCH_HOLDS_START";
export const FETCH_HOLDS_SUCCESS = "FETCH_HOLDS_SUCCESS";
export const FETCH_HOLDS_FAIL = "FETCH_HOLDS_FAIL";

export const FETCH_INACTIVE_HOLDS_START = "FETCH_INACTIVE_HOLDS_START";
export const FETCH_INACTIVE_HOLDS_SUCCESS = "FETCH_INACTIVE_HOLDS_SUCCESS";
export const FETCH_INACTIVE_HOLDS_FAIL = "FETCH_INACTIVE_HOLDS_FAIL";

export const ADD_HOLDS_START = "ADD_HOLDS_START";
export const ADD_HOLDS_SUCCESS = "ADD_HOLDS_SUCCESS";
export const ADD_HOLDS_FAIL = "ADD_HOLDS_FAIL";

export const FETCH_PUBLISHING_CHECKLIST_START = "FETCH_PUBLISHING_CHECKLIST_START";
export const FETCH_PUBLISHING_CHECKLIST_SUCCESS = "FETCH_PUBLISHING_CHECKLIST_SUCCESS";
export const FETCH_PUBLISHING_CHECKLIST_FAIL = "FETCH_PUBLISHING_CHECKLIST_FAIL";

export const FETCH_MARKETPLACE_START = "FETCH_MARKETPLACE_START";
export const FETCH_MARKETPLACE_SUCCESS = "FETCH_MARKETPLACE_SUCCESS";
export const FETCH_MARKETPLACE_FAIL = "FETCH_MARKETPLACE_FAIL";

export const FETCH_RECALL_TAB_START = "FETCH_RECALL_TAB_START";
export const FETCH_RECALL_TAB_SUCCESS = "FETCH_RECALL_TAB_SUCCESS";
export const FETCH_RECALL_TAB_FAIL = "FETCH_RECALL_TAB_FAIL";

export const FETCH_REVIEW_TAB_DETAILS_START = "FETCH_REVIEW_TABS_DETAILS_START";
export const FETCH_REVIEW_TAB_DETAILS_SUCCESS = "FETCH_REVIEW_TABS_DETAILS_SUCCESS";
export const FETCH_REVIEW_TAB_DETAILS_FAIL = "FETCH_REVIEW_TABS_DETAILS_FAIL";

export const FETCH_SOLD_QC_DETAILS_REQUEST = "FETCH_SOLD_QC_DETAILS_REQUEST";
export const FETCH_SOLD_QC_DETAILS_SUCCESS = "FETCH_SOLD_QC_DETAILS_SUCCESS";
export const FETCH_SOLD_QC_DETAILS_FAILURE = "FETCH_SOLD_QC_DETAILS_FAILURE";

export const FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_REQUEST = "FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_REQUEST";
export const FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_SUCCESS = "FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_SUCCESS";
export const FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_FAILURE = "FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_FAILURE";

export const FETCH_VIDEOGRAPHY_PROMPT_REQUEST = "FETCH_VIDEOGRAPHY_PROMPT_REQUEST";
export const FETCH_VIDEOGRAPHY_PROMPT_SUCCESS = "FETCH_VIDEOGRAPHY_PROMPT_SUCCESS";
export const FETCH_VIDEOGRAPHY_PROMPT_FAILURE = "FETCH_VIDEOGRAPHY_PROMPT_FAILURE";

export const UPDATE_VIDEOGRAPHY_PROMPT_REQUEST = "UPDATE_VIDEOGRAPHY_PROMPT_REQUEST";
export const UPDATE_VIDEOGRAPHY_PROMPT_SUCCESS = "UPDATE_VIDEOGRAPHY_PROMPT_SUCCESS";
export const UPDATE_VIDEOGRAPHY_PROMPT_FAILURE = "UPDATE_VIDEOGRAPHY_PROMPT_FAILURE";

export const FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_REQUEST = "FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_REQUEST";
export const FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_SUCCESS = "FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_SUCCESS";
export const FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_FAILURE = "FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_FAILURE";

export const SET_VIDEOGRAPHY_QC_ACTION_TYPE = "SET_VIDEOGRAPHY_QC_ACTION_TYPE";

export const FETCH_PROCESS_TRACKER_DETAILS_REQUEST = "FETCH_PROCESS_TRACKER_DETAILS_REQUEST";
export const FETCH_PROCESS_TRACKER_DETAILS_SUCCESS = "FETCH_PROCESS_TRACKER_DETAILS_SUCCESS";
export const FETCH_PROCESS_TRACKER_DETAILS_FAILURE = "FETCH_PROCESS_TRACKER_DETAILS_FAILURE";

export const SET_AUDIO_NODE_PROCESS_TRACKER = "SET_AUDIO_NODE_PROCESS_TRACKER";
export const RESET_PROCESS_TRACKER_DETAILS = "RESET_PROCESS_TRACKER_DETAILS";

export const COMPLETE_VIDEOGRAPHY_QC_ACTION_REQUEST = "COMPLETE_VIDEOGRAPHY_QC_ACTION_REQUEST";
export const COMPLETE_VIDEOGRAPHY_QC_ACTION_SUCCESS = "COMPLETE_VIDEOGRAPHY_QC_ACTION_SUCCESS";
export const COMPLETE_VIDEOGRAPHY_QC_ACTION_FAILURE = "COMPLETE_VIDEOGRAPHY_QC_ACTION_FAILURE";

export const UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_REQUEST = "UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_REQUEST";
export const UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_SUCCESS = "UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_SUCCESS";
export const UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_FAILURE = "UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_FAILURE";

export const FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_REQUEST = "FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_REQUEST";
export const FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_SUCCESS = "FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_SUCCESS";
export const FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_FAILURE = "FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_FAILURE";

export const RESET_FINAL_VIDEO_EXTRACTION = "RESET_FINAL_VIDEO_EXTRACTION";
export const RESET_FINAL_VIDEO_DETAILS = "RESET_FINAL_VIDEO_DETAILS";

export const UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_REQUEST = "UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_REQUEST";
export const UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_SUCCESS = "UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_SUCCESS";
export const UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_FAILURE = "UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_FAILURE";

export const TOGGLE_VIDEOGRAPHY_CONFIRM_MODAL = "TOGGLE_VIDEOGRAPHY_CONFIRM_MODAL";
export const SET_VIDEOGRAPHY_CONFIRM_MODAL = "SET_VIDEOGRAPHY_CONFIRM_MODAL";
export const TOGGLE_VIDEOGRAPHY_CONFIRM_MODAL_LOADING = "TOGGLE_VIDEOGRAPHY_CONFIRM_MODAL_LOADING";

export const TOGGLE_VIDEOGRAPHY_UPLOAD_MODAL = "TOGGLE_VIDEOGRAPHY_UPLOAD_MODAL";
export const SET_VIDEOGRAPHY_UPLOAD_MODAL = "SET_VIDEOGRAPHY_UPLOAD_MODAL";
export const SET_VIDEOGRAPHY_UPLOAD_STATUS = "SET_VIDEOGRAPHY_UPLOAD_STATUS";

export const UPLOAD_FINAL_VIDEO_PLATFORM_REQUEST = "UPLOAD_FINAL_VIDEO_PLATFORM_REQUEST";
export const UPLOAD_FINAL_VIDEO_PLATFORM_SUCCESS = "UPLOAD_FINAL_VIDEO_PLATFORM_SUCCESS";
export const UPLOAD_FINAL_VIDEO_PLATFORM_FAILURE = "UPLOAD_FINAL_VIDEO_PLATFORM_FAILURE";

export const GENERATE_FINAL_VIDEO_CHAPTER_GIF_REQUEST = "GENERATE_FINAL_VIDEO_CHAPTER_GIF_REQUEST";
export const GENERATE_FINAL_VIDEO_CHAPTER_GIF_SUCCESS = "GENERATE_FINAL_VIDEO_CHAPTER_GIF_SUCCESS";
export const GENERATE_FINAL_VIDEO_CHAPTER_GIF_FAILURE = "GENERATE_FINAL_VIDEO_CHAPTER_GIF_FAILURE";

export const CHECK_FINAL_VIDEO_PLATFORM_STATUS_REQUEST = "CHECK_FINAL_VIDEO_PLATFORM_STATUS_REQUEST";
export const CHECK_FINAL_VIDEO_PLATFORM_STATUS_SUCCESS = "CHECK_FINAL_VIDEO_PLATFORM_STATUS_SUCCESS";
export const CHECK_FINAL_VIDEO_PLATFORM_STATUS_FAILURE = "CHECK_FINAL_VIDEO_PLATFORM_STATUS_FAILURE";

export const PUBLISH_FINAL_VIDEO_REQUEST = "PUBLISH_FINAL_VIDEO_REQUEST";
export const PUBLISH_FINAL_VIDEO_SUCCESS = "PUBLISH_FINAL_VIDEO_SUCCESS";
export const PUBLISH_FINAL_VIDEO_FAILURE = "PUBLISH_FINAL_VIDEO_FAILURE";

export const FETCH_PAYMENT_DETAILS_START = "FETCH_PAYMENT_DETAILS_START";
export const FETCH_PAYMENT_DETAILS_SUCCESS = "FETCH_PAYMENT_DETAILS_SUCCESS";
export const FETCH_PAYMENT_DETAILS_FAIL = "FETCH_PAYMENT_DETAILS_FAIL";

export const MODIFY_PAYMENT_STATUS_START = "MODIFY_PAYMENT_STATUS_START";
export const MODIFY_PAYMENT_STATUS_SUCCESS = "MODIFY_PAYMENT_STATUS_SUCCESS";
export const MODIFY_PAYMENT_STATUS_FAIL = "MODIFY_PAYMENT_STATUS_FAIL";
